import { CHANGE_TIER } from "../constants/missionConstants";

export const changeTier = (tier) => async (dispatch) => {
  dispatch({
    type: CHANGE_TIER,
    payload: tier,
  });
};
